import React from 'react'
import { TableCell } from '@mui/material'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

export function BlackListTableItems({ item }) {
    const navigate = useNavigate()
    const entity = item?.tenantEntity ? item.tenantEntity : null

    const redirectPage = () => {
        if (entity.id) {
            navigate('/tenant-analytics', { state: { id: entity.externalId } }) // 👈 pass as state
        }
    }

    return (
        <>
            <TableCell>
                {item.blackListTypeId}
            </TableCell>
            <TableCell>
                {moment(entity.createdAt).format('YYYY-MM-DD HH:mm')}
            </TableCell>
            <TableCell>
                {item.tenantId}
            </TableCell>
            <TableCell>
                {entity?.district ? entity.district.name : 'N/A'}
            </TableCell>
            <TableCell>
                {entity.name}
            </TableCell>
            <TableCell>
                {entity?.region ? entity.region.name : 'N/A'}
            </TableCell>
            <TableCell>
                {moment(entity.updatedAt).format('YYYY-MM-DD HH:mm')}
            </TableCell>
            <TableCell>
                <button
                    onClick={() => redirectPage()}
                    className="px-[15px] py-[10px] bg-main-300 text-white font-[500] rounded-[7px]"
                >
                    Details
                </button>
            </TableCell>
        </>
    )
}
